import * as React from "react";
const SvgWorkstation20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5 0H4v8h12V0h-5v1.5H9V0H5Zm8 2.5V2h1v4H6V2h1v1.5h6v-1ZM0 12h2v8h2v-8h12v8h2v-8h2v-2H0v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgWorkstation20Px;
